import { DefaultState } from 'store/reducers/types';

export const READ_FUTURE_WORK_BY_DATA_REQUEST = "READ_FUTURE_WORK_BY_DATA_REQUEST";
export const READ_FUTURE_WORK_BY_DATA_SUCCESS = "READ_FUTURE_WORK_BY_DATA_SUCCESS";
export const READ_FUTURE_WORK_BY_DATA_FAILURE = "READ_FUTURE_WORK_BY_DATA_FAILURE";

export interface FutureWorkByRow {
  assignedPending: number;
  assignedUnconfirmed: number;
  backupCount: number;
  id: number;
  clientName: string;
  didNotConfirm: number;
  filled: string;
  leftCount: number;
  needed: number;
  onHold: number;
  pendingAssignment: number;
  repHasApplied: number;
};

export interface FutureWorkByData {
  rows: FutureWorkByRow[] | [];
  totalCount: number;
};

export type FutureWorkByState = DefaultState & {
  contents?: FutureWorkByData;
};

interface ReadFutureWorkByDataRequest {
  type: typeof READ_FUTURE_WORK_BY_DATA_REQUEST;
};

interface ReadFutureWorkByDataSuccess {
  type: typeof READ_FUTURE_WORK_BY_DATA_SUCCESS,
  contents: FutureWorkByData
}

interface ReadFutureWorkByDataFailure {
  type: typeof READ_FUTURE_WORK_BY_DATA_FAILURE;
}

export type FutureWorkByActionTypes = ReadFutureWorkByDataRequest | ReadFutureWorkByDataSuccess | ReadFutureWorkByDataFailure;
  